import React from 'react';
import CalendarMonthlyView from '../../../components/views/CalendarMonthlyView';



export default class Month extends React.Component {

    // nextStage = (cb) => {
    //     // this.setState({ isLoading: true, errors: {} })
    //     if (this.form) {
    //         let data = this.form.getForm()
    //         if (data) {
    //             this.props.setData(data, () => {
    //                 // this.props.postUserInfo((result, err) => {
    //                 // if (err) { this.setState({ errors: err }) }
    //                 // this.setState({ isLoading: false })
    //                 this.props.chooseNextPage()

    //                 // })
    //             })
    //         }
    //     }
    // }

    render() {
        return (


            <CalendarMonthlyView data={this.props.data} submitForm={this.props.submitForm} tasks={this.props.tasks} daysData={this.props.daysData} view={this.props.view} currentCalendar={this.props.currentCalendar} functionsHandler={this.props.functionsHandler}   headers={this.props.headers} width={this.props.width}/>
        )
    }
}